import React from 'react';
import { useInView } from 'react-intersection-observer';

export default function PriceComparison() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const problems1 = [
    { icon: '💰', text: '動画制作の予算が全然ない' },
    { icon: '⏰', text: '開発で手一杯で動画作る時間がない' },
    { icon: '😱', text: '動画編集ソフトの使い方が分からない' },
    { icon: '🎯', text: 'ユーザーに刺さる説明ができない' },
    { icon: '💭', text: 'プロダクトの魅力が伝えられない' },
    { icon: '📊', text: 'マーケティングの知識が乏しい' },
    { icon: '🤔', text: '何から始めればいいか分からない' },
    { icon: '⚠️', text: 'SNSのアルゴリズムが理解できない' },
    { icon: '📱', text: '動画のサイズ比率が分からない' },
    { icon: '🎬', text: 'BGMの選び方が分からない' },
    { icon: '🔍', text: 'ターゲットユーザーが見つからない' },
    { icon: '😫', text: '撮影の経験が全くない' },
  ];

  const problems2 = [
    { icon: '🌐', text: 'プラットフォームごとの特性が分からない' },
    { icon: '📈', text: '再生数が全然伸びない' },
    { icon: '🎨', text: 'サムネイルのセンスがない' },
    { icon: '🗣️', text: 'ナレーション・声が苦手' },
    { icon: '📝', text: '台本の書き方が分からない' },
    { icon: '🎵', text: '著作権の知識が不安' },
    { icon: '💻', text: '開発に専念できない' },
    { icon: '🤦', text: 'コメント対応する余裕がない' },
    { icon: '📋', text: 'KPIの設定方法が分からない' },
    { icon: '⚡', text: 'トレンドについていけない' },
    { icon: '🎭', text: '人前で話すのが苦手' },
    { icon: '😔', text: '投稿を継続する自信がない' },
  ];

  return (
    <section className="">
      <div className="container mx-auto">
        <div className="max-w-6xl mx-auto" ref={ref}>
          <div className="text-center mb-20">
            <h2 className={`text-3xl md:text-4xl font-bold bg-gradient-to-r from-indigo-600 to-blue-500 bg-clip-text text-transparent mb-4 transition-all duration-700 ${
              inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}>
              動画製作<br/>自分で継続はキツい...
            </h2>
            <div className="mt-8 relative">
              <div className="flex justify-center overflow-hidden py-4">
                <div className="flex flex-nowrap gap-4 animate-[slideLeftSlow1_50s_linear_infinite] hover:[animation-play-state:paused]">
                  {[...problems1, ...problems1, ...problems1].map((item, index) => (
                    <div
                      key={index}
                      className="shrink-0"
                    >
                      <div className="inline-flex items-center gap-3 px-6 py-2 bg-red-50/30 backdrop-blur-sm rounded-full border border-red-200/30 shadow-lg whitespace-nowrap hover:scale-105 hover:bg-red-50/50 transition-all">
                        <span className="text-2xl">{item.icon}</span>
                        <span className="text-lg font-medium text-red-700/80">{item.text}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {/* グラデーションオーバーレイ */}
              <div className="absolute left-0 top-0 w-32 h-full bg-gradient-to-r from-gray-50 to-transparent z-10"></div>
              <div className="absolute right-0 top-0 w-32 h-full bg-gradient-to-l from-gray-50 to-transparent z-10"></div>
            </div>
            
            {/* 2段目：少し遅い速度で流れる問題点 */}
            <div className="relative">
              <div className="flex justify-center overflow-hidden py-4">
                <div className="flex flex-nowrap gap-4 animate-[slideLeftSlow2_65s_linear_infinite] hover:[animation-play-state:paused]">
                  {[...problems2, ...problems2, ...problems2].map((item, index) => (
                    <div
                      key={index}
                      className="shrink-0"
                    >
                      <div className="inline-flex items-center gap-3 px-6 py-2 bg-red-50/30 backdrop-blur-sm rounded-full border border-red-200/30 shadow-lg whitespace-nowrap hover:scale-105 hover:bg-red-50/50 transition-all">
                        <span className="text-2xl">{item.icon}</span>
                        <span className="text-lg font-medium text-red-700/80">{item.text}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {/* グラデーションオーバーレイ */}
              <div className="absolute left-0 top-0 w-32 h-full bg-gradient-to-r from-gray-50 to-transparent z-10"></div>
              <div className="absolute right-0 top-0 w-32 h-full bg-gradient-to-l from-gray-50 to-transparent z-10"></div>
            </div>

            
          </div>        
        </div>
      </div>
    </section>
  );
}